import { useEffect, useState } from 'react'
export const useContainer = (apiUrl) => {
    const [items, setItems] = useState([])
    const [loading, setLoading] = useState(true)


    useEffect(() => {
        async function fetchItems() {
          const response = await fetch(apiUrl);

          const data = await response.json();
          setTimeout(() => {
            setItems(data);
            setLoading(false)
          }, 500)
        }
    
        fetchItems();
      }, [apiUrl]);
    
      return { items, loading };

    }

